var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,47.4C24,47.4,24,47.4,24,47.4c-6.3,0-12.3-2.4-16.7-6.9c-4.5-4.5-6.9-10.4-6.9-16.7c0-11.2,7.9-20.9,18.9-23.2 c0.8-0.2,1.7,0.2,2.1,0.9s0.4,1.7-0.2,2.3c-2.4,2.9-3.6,6.6-3.2,10.4c0.4,3.8,2.2,7.2,5.1,9.6c6,5,15,4.2,20-1.9 c0.3-0.4,0.6-0.7,0.8-1.1c0.5-0.7,1.4-1,2.2-0.8c0.8,0.2,1.4,0.9,1.5,1.8c0.1,0.7,0.1,1.3,0.1,1.9C47.6,36.8,37,47.4,24,47.4z  M15.1,6.3C8.7,9.6,4.4,16.3,4.4,23.8c0,5.2,2,10.1,5.8,13.8c3.7,3.7,8.6,5.7,13.8,5.7c0,0,0,0,0,0c0,0,0,0,0,0 c9.5,0,17.5-6.9,19.2-16c-6.6,5.1-16.1,5.1-22.7-0.4c-3.7-3.1-6.1-7.5-6.5-12.3C13.7,11.8,14.1,8.9,15.1,6.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/Dark Mode.0e26b44fdb47238e618082805f2cf377.svg";
export { ForwardRef as ReactComponent };